export const Footer = () => (
    <footer className="app-footer dashboard-footer hide-from-printer">
        <h5>&copy; {new Date().getFullYear()} - TotalEquipIQ</h5>
    </footer>
);
